@if (requiredAgreement$ | async; as agreement) {
  <div class="flex flex-col h-full items-center overflow-x-auto">
    <p class="flex-none font-medium text-2xl text-center pt-10 lg:pt-20 pb-5 lg:pb-10">
      {{agreement.name}}
    </p>
    <div class="flex-1 overflow-y-auto mx-[30px] lg:mx-[45px] lg:mx-8">
      <div class="overflow-x-hidden justify-center pr-3">
        @if (checkForHTMLTags(agreement.agreement_text)) {
          <p [innerHTML]="agreement.agreement_text"></p>
        }
        @if (!checkForHTMLTags(agreement.agreement_text)) {
          <p [innerText]="agreement.agreement_text"></p>
        }
      </div>
    </div>
    <div class="lg:mx-[45px] lg:mx-8">
      <p class="text-exam pt-5 font-medium text-exam-red">
        {{agreement.notice_text}}
      </p>
      <div class="text-exam pt-5 font-medium text-center">
        {{agreement.accept_text}}
      </div>
    </div>
    <div class="flex justify-center py-5 gap-5">
      <!-- TODO fix button small height -->
      <button mat-flat-button color="primary" class="text-md" (click)="onAcceptClick(agreement.agreement_id)">
        Accept
      </button>
    </div>
  </div>
} @else {
  Loading
}

